import axios from 'axios'

const REQUESTS_AUTH_TOKEN_KEY = 'requests_api_auth_token'
const requestsAuthClient = axios.create()
const TOKEN_EXPIRY_SKEW_MS = 60 * 1000

const REQUESTS_API_BASE_URL = process.env.REACT_APP_BASE_URL_REQUESTS
const REQUESTS_AUTH_LOGIN_URL =
  process.env.REACT_APP_REQUESTS_AUTH_LOGIN_URL ||
  'https://apim-as-global-prd.azure-api.net/security/auth/login'
const REQUESTS_AUTH_SUBSCRIPTION_KEY =
  process.env.REACT_APP_REQUESTS_AUTH_SUBSCRIPTION_KEY

let authRequestPromise = null

const decodeJwtPayload = (token) => {
  try {
    const payload = token.split('.')[1]

    if (!payload) return null

    const normalizedPayload = payload.replace(/-/g, '+').replace(/_/g, '/')
    const paddedPayload = normalizedPayload.padEnd(
      Math.ceil(normalizedPayload.length / 4) * 4,
      '='
    )

    return JSON.parse(window.atob(paddedPayload))
  } catch (error) {
    return null
  }
}

const isTokenExpired = (token) => {
  const payload = decodeJwtPayload(token)

  if (!payload?.exp) {
    return false
  }

  return payload.exp * 1000 <= Date.now() + TOKEN_EXPIRY_SKEW_MS
}

const getStoredToken = () => {
  const token = window.localStorage.getItem(REQUESTS_AUTH_TOKEN_KEY)

  if (!token) {
    return null
  }

  if (isTokenExpired(token)) {
    window.localStorage.removeItem(REQUESTS_AUTH_TOKEN_KEY)
    return null
  }

  return token
}

const storeToken = (token) => {
  window.localStorage.setItem(REQUESTS_AUTH_TOKEN_KEY, token)
}

export const clearRequestsAuthToken = () => {
  window.localStorage.removeItem(REQUESTS_AUTH_TOKEN_KEY)
}

const getAbsoluteUrl = (url) => {
  if (!url) return ''

  try {
    return new URL(url, window.location.origin).toString()
  } catch (error) {
    return url
  }
}

export const isRequestsApiUrl = (url) => {
  if (!REQUESTS_API_BASE_URL || !url) return false

  return getAbsoluteUrl(url).startsWith(REQUESTS_API_BASE_URL)
}

const extractToken = (payload) => {
  if (!payload) return null

  return (
    payload.token ||
    payload.access_token ||
    payload.accessToken ||
    payload?.data?.token ||
    payload?.data?.access_token ||
    payload?.data?.accessToken ||
    null
  )
}

const fetchRequestsAuthToken = async () => {
  if (!REQUESTS_AUTH_SUBSCRIPTION_KEY) {
    throw new Error(
      'Falta la subscription key para autenticar solicitudes protegidas.'
    )
  }

  const { data } = await requestsAuthClient.post(
    REQUESTS_AUTH_LOGIN_URL,
    {},
    {
      headers: {
        'Ocp-Apim-Subscription-Key': REQUESTS_AUTH_SUBSCRIPTION_KEY,
        'Content-Type': 'application/json'
      }
    }
  )

  const token = extractToken(data)

  if (!token) {
    throw new Error('No fue posible obtener el token de autenticacion.')
  }

  storeToken(token)

  return token
}

export const getRequestsAuthToken = async () => {
  const storedToken = getStoredToken()

  if (storedToken) {
    return storedToken
  }

  if (!authRequestPromise) {
    authRequestPromise = fetchRequestsAuthToken().finally(() => {
      authRequestPromise = null
    })
  }

  return authRequestPromise
}
